document.addEventListener('DOMContentLoaded', function () {
  // 回到顶部
  document.querySelector('.yg-to-top').addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  if (window.scrollY > 100) {
    document.querySelector('.yg-to-top').classList.add('show');
  } else {
    document.querySelector('.yg-to-top').classList.remove('show');
  }

  window.addEventListener('scroll', function () {
    if (window.scrollY > 100) {
      document.querySelector('.yg-to-top').classList.add('show');
    } else {
      document.querySelector('.yg-to-top').classList.remove('show');
    }
  });
  

  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGDeferredMedia extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['playing'];
    }

    connectedCallback() {
      this.bindPosterButton();

      this.addEventListener('click', (e) => {
        const video = this.querySelector('video')
        if (
          video &&
          e.target === video &&
          !video.hasAttribute('controls')
        ) {
          e.preventDefault()
          e.stopPropagation()
          if (this.playing) {
            this.pause()
          } else {
            this.play()
          }
        }
      });

      if (this.autoplay) {
        this.inViewObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.init();
            }
          });
        });
        this.inViewObserver.observe(this);
      }
    }

    get posterElement() {
      return this.querySelector('[id^="YG-DeferredPoster-"]');
    }

    get autoplay() {
      return this.hasAttribute('autoplay');
    }

    get playing() {
      return this.hasAttribute('playing');
    }

    get player() {
      return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
        get: (target, prop) => {
          return async () => {
            target = await target;
            this.playerHandler(target, prop);
          };
        }
      });
    }

    bindPosterButton() {
      const poster = this.posterElement;
      if (poster && !poster.hasListener) {
        poster.addEventListener('click', this.onPosterClick.bind(this));
        poster.hasListener = true;
      }
    }

    async playerTarget() {
      const template = this.querySelector('template');
      if (!template) return Promise.resolve(null);

      if (!this.mediaElement) {
        const fragment = template.content.cloneNode(true);
        this.appendChild(fragment);
        this.mediaElement = this.querySelector('video, iframe');
      }

      this.bindPosterButton();
      return Promise.resolve(this.mediaElement);
    }

    playerHandler(target, prop) {
      if (!target) return;

      if (prop === 'play' && typeof target.play === 'function') {
        target.play();
        this.setAttribute('playing', '');
        this.removeAttribute('paused');
      }

      if (prop === 'pause' && typeof target.pause === 'function') {
        target.pause();
        this.removeAttribute('playing');
        this.setAttribute('paused', '');
      }
    }

    onPosterClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    }

    init() {
      if (!this.paused) {
        this.play();
      }
      return () => this.pause();
    }

    play() {
      if (!this.playing) {
        this.player.play();
      }
    }

    pause() {
      if (this.playing) {
        this.player.pause();
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'playing') {
        if (oldValue === null && newValue === '') {
          this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
          this.removeAttribute('paused');
        }
        if (newValue === null) {
          this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
          this.setAttribute('paused', '');
        }
      }
    }
  }

  class YGMedia extends YGDeferredMedia {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback(); // 保留父类逻辑

      if (!this.querySelector('img') && !this.hasAttribute('autoplay')) {
        this.inViewObserverNoAutoplay = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadMediaOnly();
              this.inViewObserverNoAutoplay.disconnect();
            }
          });
        });
        this.inViewObserverNoAutoplay.observe(this);
      }
    }

    async loadMediaOnly() {
      if (!this.mediaElement) {
        const template = this.querySelector('template');
        if (template) {
          const fragment = template.content.cloneNode(true);
          this.appendChild(fragment);
          this.mediaElement = this.querySelector('video, iframe');
          this.setAttribute('loaded', '');
          this.closest('.media')?.classList.remove('loading');
          this.bindPosterButton();
        }
      }
    }

    async playerTarget() {
      if (this.hasAttribute('host')) {
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        return new Promise(async (resolve) => {
          const templateElement = this.querySelector('template');
          if (templateElement) {
            templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
          }
          this.bindPosterButton();

          const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('(max-width: 1023px)').matches;
          const host = this.getAttribute('host');

          if (host === 'youtube') {
            if (!window.YT || !window.YT.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                
                script.onload = res;
                document.head.appendChild(script);
              });
              await new Promise(res => {
                window.onYouTubeIframeAPIReady = res;
              });
            }

            const player = new YT.Player(this.querySelector('iframe'), {
              events: {
                onReady: () => {
                  if (muteVideo) player.mute();
                  resolve(player);
                },
                onStateChange: (event) => {
                  if (event.data === YT.PlayerState.PLAYING) {
                    this.setAttribute('playing', '');
                    this.removeAttribute('paused');
                  }
                  if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    this.removeAttribute('playing');
                    this.setAttribute('paused', '');
                  }
                }
              }
            });
          }

          if (host === 'vimeo') {
            if (!window.Vimeo || !window.Vimeo.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://player.vimeo.com/api/player.js';
                script.onload = res;
                document.head.appendChild(script);
              });
            }

            const player = new Vimeo.Player(this.querySelector('iframe'));
            if (muteVideo) await player.setMuted(true);

            player.on('play', () => {
              this.setAttribute('playing', '');
              this.removeAttribute('paused');
            });
            player.on('pause', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });
            player.on('ended', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });

            resolve(player);
          }

          if (host === 'pimmedia') {
            // 假设 pimmedia 的 iframe 已经在页面上
            const iframe = this.querySelector('iframe');
            console.log("第三季我")
            if (!iframe) {
              console.warn('pimmedia iframe not found');
              return;
            }

            // 假设 mute 需要 postMessage 或类似接口，这里根据你具体接口改写
            if (muteVideo) {
              // 这里看你的 pimmedia 播放器怎么静音，比如 postMessage
              iframe.contentWindow.postMessage({ action: 'mute' }, '*');
            }

            // 监听 pimmedia 的消息事件（例如播放、暂停、结束）
            window.addEventListener('message', (event) => {
              // 确认是 pimmedia 的消息，可根据 event.origin 做验证
              const data = event.data;

              if (typeof data !== 'object' || !data.event) return;

              if (data.event === 'play') {
                this.setAttribute('playing', '');
                this.removeAttribute('paused');
              }
              if (data.event === 'pause' || data.event === 'ended') {
                this.removeAttribute('playing');
                this.setAttribute('paused', '');
              }
            });

            // 返回一个模拟的 player 对象给 resolve
            resolve({
              play() {
                iframe.contentWindow.postMessage({ action: 'play' }, '*');
              },
              pause() {
                iframe.contentWindow.postMessage({ action: 'pause' }, '*');
              },
              mute() {
                iframe.contentWindow.postMessage({ action: 'mute' }, '*');
              }
            });
          }
        });
      } else {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        const player = this.querySelector('video');
        player.addEventListener('play', () => {
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
          this.removeAttribute('suspended');
        });
        player.addEventListener('pause', () => {
          if (!player.seeking && player.paused) {
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        });

        this.bindPosterButton();
        return player;
      }
    }

    playerHandler(target, prop) {
      const host = this.getAttribute('host');

      if (host === 'youtube') {
        if (prop === 'play') {
          target.playVideo();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pauseVideo();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else if (host === 'vimeo') {
        if (prop === 'play') {
          target.play();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else {
        if (prop === 'play') {
          target.play().catch((error) => {
            if (error.name === 'NotAllowedError') {
              this.setAttribute('suspended', '');
              target.controls = true;
              const replacementImageSrc = target.previousElementSibling?.currentSrc;
              if (replacementImageSrc) {
                target.poster = replacementImageSrc;
              }
            }
          });
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      }
    }
  }

  if (!customElements.get('yg-video')) {
    customElements.define('yg-video', YGMedia);
  }

  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        loop: this['loop'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

})
